import { FaStar } from "react-icons/fa";


const Dufflesdata = {
  productData: [
  //   {
  //       id:1,
  //       img: require('./Backpacks/HB3001005_1.jpg'),
  //       title:'Mintox',
  //       price: '2790',
  //       oldprice: '2999',
  //       desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  //       star1: <FaStar />,
  //       star2: <FaStar />,
  //       star3: <FaStar />,
  //       star4: <FaStar />
  //   },
  //   {
  //     id:2,
  //     img: require('./Backpacks/HL4009008_1.jpg'),
  //     title:'Mintox',
  //     price: '2790',
  //     oldprice: '2999',
  //     desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  //     star1: <FaStar />,
  //     star2: <FaStar />,
  //     star3: <FaStar />,
  //     star4: <FaStar />
  // },
  {
    id:3,
    img: require('./Backpacks/LN6059201_1.jpg'),
    title:'Mintox',
    price: '2790',
    oldprice: '2999',
    desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
    star1: <FaStar />,
    star2: <FaStar />,
    star3: <FaStar />,
    star4: <FaStar />
},{
  id:4,
  img: require('./Backpacks/LN8064101_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
}
,{
  id:5,
  img: require('./Backpacks/LO1090001_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:6,
  img: require('./Backpacks/LO7000101_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:7,
  img: require('./Backpacks/LP0008001_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},{
  id:8,
  img: require('./Backpacks/LP3001301_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:9,
  img: require('./Backpacks/LP4000101_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:10,
  img: require('./Backpacks/LP4006102_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},{
  id:11,
  img: require('./Backpacks/LT6001001_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:12,
  img: require('./Backpacks/LT7001001_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:13,
  img: require('./Backpacks/LT8000001_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:14,
  img: require('./Backpacks/LU2000001_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:15,
  img: require('./Backpacks/LU2000001_2.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:16,
  img: require('./Backpacks/LU4001001_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:17,
  img: require('./Backpacks/LU5001002_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
},
{
  id:18,
  img: require('./Backpacks/QI5006002_1.jpg'),
  title:'Mintox',
  price: '2790',
  oldprice: '2999',
  desc: 'Safari Coastline Printed Trolley Bag with Anti Theft Zipper',
  star1: <FaStar />,
  star2: <FaStar />,
  star3: <FaStar />,
  star4: <FaStar />
}
  ],
};

export default Dufflesdata; 